import styled from "styled-components"
import {Label} from "@irati/ui/src/Typography"

export interface TextHelperProps {
  hasError?: boolean
}

export const TextHelper = styled(Label)<TextHelperProps>`
  display: inline-flex;
  align-items: center;
  line-height: 1;
  color: ${({theme, hasError}) => hasError && theme.colors.tertiary.r_400};
`
